import React, { useMemo } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { logPostHogEvent, getDealsString, getBrands } from '@utils/index';
import { DealPostType } from '@types';

const FilterByBrand = ({
  deals,
  brandFilter,
  setBrandFilter
}: {
  deals: DealPostType[];
  brandFilter: string;
  setBrandFilter: (brand: string) => void;
}) => {
  const brands = useMemo(() => getBrands(deals), [deals]);

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="filter-by-brand-label">Filter By Brand</InputLabel>
      <Select
        labelId="filter-by-brand-label"
        id="filter-by-brand"
        value={brandFilter}
        label="Filter By Brand"
        onChange={(e) => {
          setBrandFilter(e.target.value as string);
          logPostHogEvent('page-deal-filter-by-brand', {
            value: e.target.value
          });
        }}
      >
        <MenuItem value="ALL_BRANDS">All Brands</MenuItem>
        {brands.map((brand) => (
          <MenuItem
            key={brand.value}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: 1.2
            }}
            value={brand.value}
          >
            {`${brand.amount} ${getDealsString(brand.amount)} — ${brand.label}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterByBrand;
